var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import elementInViewport from './inview';
import generator from './generateUniqueId';
import api from './api';
var isInViewChecker = {};
var timeInView = {};
var postStatistics = function (events) {
    var _a;
    // dispatch customer window event
    // reserved for customer
    if ((_a = window === null || window === void 0 ? void 0 : window._mensenlinqEvents) === null || _a === void 0 ? void 0 : _a.emit) {
        window._mensenlinqEvents.emit('mensenlinq-event', {
            events: events,
        });
    }
    api.post('statistics', {
        payload: events,
    }, {
        'X-Customer-Id': window._mensenlinqGlobalStatistics.id,
    })
        .then(function () { })
        .catch(function (error) {
        console.error(error);
    });
};
var bufferStatistics = function (event) {
    var _a;
    if (window._mensenlinqGlobalStatistics.events) {
        window._mensenlinqGlobalStatistics.events.push(event);
    }
    clearTimeout(window._mensenlinqGlobalStatistics.buffer);
    if (!((_a = window === null || window === void 0 ? void 0 : window._mensenlinqGlobalStatistics.events) === null || _a === void 0 ? void 0 : _a.length)) {
        return;
    }
    window._mensenlinqGlobalStatistics.buffer = setTimeout(function () {
        postStatistics(window._mensenlinqGlobalStatistics.events);
        window._mensenlinqGlobalStatistics.events = [];
    }, 500);
};
var handleBeforeUnload = function () {
    // Send any leftover events before unloading
    postStatistics(window._mensenlinqGlobalStatistics.events);
    window._mensenlinqGlobalStatistics.events = [];
};
var stats = function (config, dom) {
    // Runtime statistics
    var handleEvent = function (_a) {
        var _b, _c;
        var type = _a.type, payload = _a.payload;
        var rawPayload = __assign(__assign({}, payload), { userSessionId: window._mensenlinqGlobalStatistics.sessionId, widgetInstanceId: config._widgetInstanceId, id: config._id, customerId: config._customerId });
        var eventPayload = __assign(__assign({}, payload), { userSessionId: window._mensenlinqGlobalStatistics.sessionId, widgetInstanceId: config._widgetInstanceId, id: config._id, customerId: config._customerId });
        // Delete unneeded information
        delete eventPayload.element;
        delete eventPayload.wrapper;
        delete eventPayload._id;
        // Dispatch the hook
        if (((_c = (_b = config === null || config === void 0 ? void 0 : config.global) === null || _b === void 0 ? void 0 : _b.hooks) === null || _c === void 0 ? void 0 : _c.onStatistics) &&
            typeof config.global.hooks.onStatistics === 'function') {
            config.global.hooks.onStatistics({
                type: type,
                payload: eventPayload,
                rawPayload: rawPayload,
            });
        }
        // Make sure we can buffer them, to reduce network throttling
        bufferStatistics({
            type: type,
            payload: payload,
        });
    };
    //
    // MAIN COMMUNICATION HOOK FOR STATISTICS EVENTS
    window._mensenlinqEvents.on('statistics', function (event) {
        handleEvent(event);
    });
    //
    // WIDGET SPECIFIC GLOBAL EVENTS
    //
    // Dispatch onload event
    var domCpy = __assign({}, dom);
    delete domCpy.__vue__; // need to strip vue from dom because of circular references
    // window._mensenlinqEvents.emit('statistics', {
    //     type: 'widget-loaded',
    //     payload: {
    //         time: Date.now(),
    //         location: window.location.href,
    //         _id: config._id,
    //         element: domCpy,
    //     },
    // })
    //
    // Dispatch widget was inview
    var dispatchInView = function (type) {
        var domCpy = __assign({}, dom);
        delete domCpy.__vue__; // need to strip vue from dom because of circular references
        var payload = {
            time: Date.now(),
            location: window.location.href,
            _id: config._id,
            element: domCpy,
            timeInViewInSeconds: null,
        };
        if (type === 'out') {
            var timepassed = timeInView[config._widgetInstanceId].out -
                timeInView[config._widgetInstanceId].in;
            timepassed = Math.round(timepassed / 1000);
            payload.timeInViewInSeconds = timepassed;
        }
        else {
            delete payload.timeInViewInSeconds;
        }
        window._mensenlinqEvents.emit('statistics', {
            type: "widget-".concat(type, "-view"),
            payload: payload,
        });
    };
    //
    // Detect inview
    isInViewChecker[config._widgetInstanceId] = false;
    var handleScrollForEvent = function () {
        var initialInView = elementInViewport(dom);
        if (initialInView && !isInViewChecker[config._widgetInstanceId]) {
            isInViewChecker[config._widgetInstanceId] = true;
            if (!timeInView[config._widgetInstanceId]) {
                timeInView[config._widgetInstanceId] = {};
            }
            timeInView[config._widgetInstanceId].in = Date.now();
            // dispatchInView('in')
        }
        else if (!initialInView &&
            isInViewChecker[config._widgetInstanceId]) {
            isInViewChecker[config._widgetInstanceId] = false;
            if (!timeInView[config._widgetInstanceId]) {
                timeInView[config._widgetInstanceId] = {};
            }
            timeInView[config._widgetInstanceId].out = Date.now();
            // dispatchInView('out')
        }
    };
    // Initial check
    handleScrollForEvent();
    // on scroll events
    window.removeEventListener('scroll', handleScrollForEvent);
    window.addEventListener('scroll', handleScrollForEvent);
    window.addEventListener('beforeunload', handleBeforeUnload);
};
// This should only be executed once.
// We store everything in the window, so the events can all be shared and initialized, preventing duplicates.
stats.init = function (config) {
    var _a, _b;
    window._mensenlinqGlobalStatistics =
        window._mensenlinqGlobalStatistics || {};
    // Window functions for tracking events and buffering them.
    if (!window._mensenlinqGlobalStatistics.init) {
        window._mensenlinqGlobalStatistics.init = true;
        if (!window._mensenlinqGlobalStatistics.sessionId) {
            window._mensenlinqGlobalStatistics.sessionId = generator();
        }
        if (!window._mensenlinqGlobalStatistics.events) {
            window._mensenlinqGlobalStatistics.events = [];
        }
        if (!window._mensenlinqGlobalStatistics.buffer) {
            window._mensenlinqGlobalStatistics.buffer = null;
        }
        // Assign a customer ID for the statistics.
        if (!window._mensenlinqGlobalStatistics.id) {
            window._mensenlinqGlobalStatistics.id = config._customerId;
        }
    }
    // Handle global events, callback for customers / partners
    if (((_b = (_a = config === null || config === void 0 ? void 0 : config.global) === null || _a === void 0 ? void 0 : _a.hooks) === null || _b === void 0 ? void 0 : _b.onStatistics) &&
        typeof config.global.hooks.onStatistics === 'function') {
        window._mensenlinqStatistics =
            window._mensenlinqStatistics || config.global.hooks.onStatistics;
    }
};
export default stats;
